import React, { useEffect } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { SettingsIcons } from "../../assets/images";
// Redux imports
import { Vendor } from "../../interfaces/account-charts";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  setFilterVendorTotalPages,
  setVendorListLoading,
} from "../../store/slices/vendorsSlice";
// API imports
import { useGetFilterVendorListMutation } from "../../services/AccountCharts";

interface Props {
  show?: boolean;
  setShow?: any;
  setVendors?: any;
  filterSearch: boolean;
  setFilterSearch: any;
  vendors: Vendor[];
  query: string;
  filterInput: FormProps;
  setFilterInput: any;
}

export interface FormProps {
  city: string;
  country: string;
  vendorStatus: string;
}

const VendorFilterModal = ({
  show,
  setShow,
  vendors,
  setVendors,
  setFilterSearch,
  query,
  filterInput,
  setFilterInput,
  filterSearch,
}: Props) => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.vendors);
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);
  const [getFilterVendorList] = useGetFilterVendorListMutation();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(setVendorListLoading(true));
    setFilterSearch(true);
    setShow(false);
    // Filter employees based on the form values
    try {
      const data = {
        userID: userID || "",
        accessToken: accessToken || "",
        permission: profileData?.permissions.showProject || false,
        payload: {
          page: state.filterVendorPageNo,
          limit: state.filterVendorPageSize,
          city: filterInput.city,
          country: filterInput.country,
          vendorStatus: filterInput.vendorStatus,
        },
      };
      const response = await getFilterVendorList(data).unwrap();
      if (response) {
        setVendors(response.data.vendors[0].data);
        dispatch(
          setFilterVendorTotalPages(response.data.vendors[0].metadata[0].total),
        );
      }
    } catch (e: any) {
    } finally {
      dispatch(setVendorListLoading(false));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      dispatch(setVendorListLoading(true));
      // Filter employees based on the form values
      try {
        const data = {
          userID: userID || "",
          accessToken: accessToken || "",
          permission: profileData?.permissions.showProject || false,
          payload: {
            page: state.filterVendorPageNo,
            limit: state.filterVendorPageSize,
            vendorId: query,
            city: filterInput.city,
            country: filterInput.country,
            vendorStatus: filterInput.vendorStatus,
          },
        };
        const response = await getFilterVendorList(data).unwrap();
        if (response) {
          setVendors(response.data.vendors[0].data);
          dispatch(
            setFilterVendorTotalPages(
              response.data.vendors[0].metadata[0].total,
            ),
          );
        }
      } catch (e: any) {
      } finally {
        dispatch(setVendorListLoading(false));
      }
    };
    if (filterSearch) {
      fetchData();
    }
  }, [state.filterVendorPageNo, state.filterVendorPageSize, query]);

  const handleReset = () => {
    setVendors(vendors);
    setFilterInput({
      city: "",
      country: "",
      vendorStatus: "",
    });
  };

  return (
    <>
      <Modal
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        className="general-modal"
      >
        <Modal.Body className="text-center px-5">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h4 className="heading">Filter Vendor List</h4>
            <button className="btn p-0 border-0" onClick={() => setShow(false)}>
              <img src={SettingsIcons.CrossIcon} alt="edit-icon" />
            </button>
          </div>
          <div className="change-password">
            <Form onSubmit={handleSubmit} className="text-end">
              <Row>
                <Col sm="6">
                  <Form.Group
                    className="mb-3 text-start"
                    controlId="formBasicEmail"
                  >
                    <h4
                      className="sub-heading normal-font-weight textBlack"
                      style={{ fontSize: "18px" }}
                    >
                      Vendor Status
                    </h4>
                    <Form.Select
                      name="vendorStatus"
                      onChange={(e) =>
                        setFilterInput({
                          ...filterInput,
                          vendorStatus: e.target.value,
                        })
                      }
                      value={filterInput.vendorStatus}
                      className="custom-input border-fill"
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="In-active">In-active</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <div className="mt-4">
                <button
                  className="btn primary-button text-center w-25 me-2"
                  onClick={handleReset}
                  type="button"
                >
                  Reset
                </button>
                <button
                  className="btn primary-button text-center w-25"
                  type="submit"
                >
                  Filter
                </button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VendorFilterModal;
